module.exports = __webpack_public_path__ + "static/media/melchior_cheese2.d7e45608.jpg";